import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { cn } from 'Utils/cn';

export default function RHFCellInputNumber({ name, min, max, decimals, className, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, onBlur, ...props }, fieldState: { error } }) => (
                <input
                    type="number"
                    className={cn(
                        'w-full font-mono text-right px-3 bg-transparent border-0 focus:outline-none h-10',
                        'text-dark-blue placeholder:text-dark-blue/50 md:text-sm',
                        '[&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]',
                        error && 'ring-1 ring-danger',
                        className,
                    )}
                    {...props}
                    {...other}
                    min={min}
                    max={max}
                    step="any"
                    onFocus={(e) => {
                        if (typeof other.onFocus === 'function') {
                            other.onFocus(e);
                        }
                    }}
                    onBlur={(e) => {
                        if (typeof other.onBlur === 'function') {
                            other.onBlur(e);
                        }
                        const value = e.target.value;
                        let numericValue = parseFloat(value);

                        if (isNaN(numericValue)) {
                            return;
                        }
                        if (decimals !== undefined) {
                            const factor = Math.pow(10, decimals);
                            numericValue = Math.trunc(numericValue * factor) / factor;
                        }
                        if (min !== undefined && numericValue < min) {
                            onChange(min);
                            return;
                        }
                        if (max !== undefined && numericValue > max) {
                            onChange(max);
                            return;
                        }
                        if (decimals !== undefined) {
                            onChange(numericValue);
                        }
                        onBlur(e);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                        }
                    }}
                    onChange={(e) => {
                        const stringValue = e.target.value;
                        const numericValue = stringValue === '' ? '' : Number(stringValue);
                        if (isNaN(numericValue)) {
                            return;
                        }
                        onChange?.(numericValue);
                        if (typeof other.onChange === 'function') {
                            other.onChange(numericValue);
                        }
                    }}
                    inputMode="decimal"
                />
            )}
        />
    );
}

RHFCellInputNumber.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
    decimals: PropTypes.number,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
};
